// src/services/bi/alerts/AlertsRecommendationsBlock.jsx
import React, { useState } from 'react';
import AlertCard from './AlertCard';

const AlertsRecommendationsBlock = ({ alerts }) => {
  const [activeTab, setActiveTab] = useState('alerts');
  const [expandedAlert, setExpandedAlert] = useState(null);

  // Séparation alertes / recommandations par priorité
  const alertItems = (alerts || [])
    .filter(a => a.priority === 'critical' || a.priority === 'warning')
    .sort((a, b) => {
      const priorityMap = { critical: 1, warning: 2 };
      return (priorityMap[a.priority] || 99) - (priorityMap[b.priority] || 99);
    });

  const recommendationItems = (alerts || [])
    .filter(a => a.priority === 'info')
    .sort((a, b) => (a.title || '').localeCompare(b.title || ''));

  const activeList = activeTab === 'alerts' ? alertItems : recommendationItems;

  // Si aucune donnée
  if (!alerts || alerts.length === 0) {
    return (
      <div className="alerts-empty">
        <div className="alerts-empty__icon">✅</div>
        <p className="alerts-empty__message">Aucune alerte actuellement. Tout est en ordre!</p>
      </div>
    );
  }

  return (
    <div className="alerts-recommendations-block">
      {/* Onglets */}
      <div className="alerts-tabs">
        <button
          className={`alerts-tab ${activeTab === 'alerts' ? 'alerts-tab--active' : ''}`}
          onClick={() => setActiveTab('alerts')}
        >
          <span className="alerts-tab__icon">⚠️</span>
          Alertes
          {alertItems.length > 0 && (
            <span className={`alerts-tab__badge alerts-tab__badge--critical`}>
              {alertItems.length}
            </span>
          )}
        </button>
        <button
          className={`alerts-tab ${activeTab === 'recommendations' ? 'alerts-tab--active' : ''}`}
          onClick={() => setActiveTab('recommendations')}
        >
          <span className="alerts-tab__icon">💡</span>
          Recommandations
          {recommendationItems.length > 0 && (
            <span className="alerts-tab__badge alerts-tab__badge--info">
              {recommendationItems.length}
            </span>
          )}
        </button>
      </div>

      {/* Liste avec scroll interne - prend tout l'espace restant */}
      <div className="alerts-scroll-container">
        {activeList.length === 0 ? (
          <div className="alerts-empty">
            <div className="alerts-empty__icon">
              {activeTab === 'alerts' ? '✅' : '💬'}
            </div>
            <p className="alerts-empty__message">
              {activeTab === 'alerts'
                ? 'Aucune alerte critique.'
                : 'Aucune recommandation disponible.'}
            </p>
          </div>
        ) : (
          <div className="alerts-container">
            {activeList.map((alert, index) => (
              <AlertCard
                key={alert.id || index}
                alert={alert}
                isExpanded={expandedAlert === alert.id}
                onToggle={() => setExpandedAlert(
                  expandedAlert === alert.id ? null : alert.id
                )}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertsRecommendationsBlock;